<template>
    <div>
        <div class="">
            <div class="mx-auto max-w-4xl px-3 pt-10 pb-32">
                <div class="max-w-md sm:max-w-xl mx-auto">
                    <p class="pl-1 font-medium text-normal">Enter a transaciton:</p>
                    <form @submit.prevent>
                    <div class="flex w-full gap-2">
                        <input type="text" v-model="demoRequest.description"
                            class="bg-white border-2 border-slate-200 rounded-xl py-3 px-4 text-lg w-full placeholder-gray-400"
                            placeholder="Selfridges [Apple Pay] 11-12-2023" id="name" name="name" />
                        <input type="number" v-model="demoRequest.amount"
                            class="w-[100px] bg-white border-2 border-slate-200 rounded-xl py-3 px-4 text-lg"
                            id="amount" placeholder="24.00" />
                    </div>
                    <div v-if="demoData != undefined" class="flex justify-center max-w-xl">
                        <ConfettiExplosion :duration="2000" :stageWidth="500" :particleCount="100" :force="0.9" />
                    </div>

                    <button @click="handleDemo" :class="loading === true ? 'opacity-80' : ''"
                        class="bg-pink-500 hover:pink-600 hover:shadow-xl border-2 border-pink-500 hover:border-pink-100 hover:border-2 cursor-pointer rounded-full py-2 px-4 text-lg w-full mt-4 text-white flex justify-center font-semibold shadow-sm">

                        <!-- <button :class="loading === true ? 'opacity-80' : ''"
                        class="bg-pink-500 hover:pink-600 hover:shadow-xl border-2 border-pink-500 hover:border-pink-100 hover:border-2 cursor-pointer rounded-full py-2 px-4 text-lg w-full mt-4 text-white flex justify-center font-semibold shadow-sm"
                        > -->
                        <p :class="loading === true ? 'hidden' : ''">Test transaction ✨</p>
                        <div :class="loading === true ? '' : 'hidden'" class="flex justify-center items-center">
                            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                            <p class="font-medium">Processing...</p>
                        </div>
                    </button>
                    </form>
                </div>
                <!-- <div class="max-w-md mx-auto px-4 py-3 mt-8 rounded-xl bg-pink-50 border border-pink-300 flex justify-start items-center gap-3 text-pink-800">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 text-pink-800">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
                    </svg>
                    <div>
                    <p class="font-medium text-sm">
                        Playground under maintenance
                    </p>
                    <p class="text-xs">
                        Come back soon to check if update has been pushed.
                    </p>
                    </div>
                </div>-->
                <div v-show="demoData != undefined && loading == false" class="mt-3">
                    <!-------------------------->
                    <!--RAW TRANSACTION INPUT -->
                    <!-------------------------->
                    <transition enter-active-class="duration-500 ease-out opacity-0 delay-[400ms]"
                        enter-to-class="opacity-100" leave-active-class="duration-500 ease-in" leave-class="opacity-100"
                        leave-to-class="opacity-0">

                        <div v-if="demoData != undefined">
                            <!--Arrow Down-->
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                                class="transition-opacity tr w-5 h-5 mx-auto my-2">
                                <path fill-rule="evenodd"
                                    d="M8 2a.75.75 0 0 1 .75.75v8.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V2.75A.75.75 0 0 1 8 2Z"
                                    clip-rule="evenodd" />
                            </svg>

                            <!--Raw transaction input-->
                            <p class=" text-sm text-gray-800 font-semibold text-center pl-1">
                                Your raw transaction input
                            </p>
                            <p class=" delay-100 text-xs text-gray-800 font-medium text-center pl-1 mb-2">
                                This represents customer spend data entering our system.
                            </p>
                            <div class="flex bg-white p-3 rounded-xl shadow-xl flex gap-x-2 max-w-md mx-auto">
                                <div class="flex w-full">
                                    <div class="bg-gray-100 py-3 px-4 rounded-lg w-full">
                                        <p class="text-xs text-gray-500 font-semibold text-left">
                                            Transaction description:
                                        </p>
                                        <div class="flex">
                                            <p class="font-bold">
                                                {{ demoData.transactionData.remittanceInformationUnstructured }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex w-[200px]">
                                    <div class="bg-gray-100 py-3 px-4 rounded-lg w-full">
                                        <p class="text-xs text-gray-500 font-semibold text-left">
                                            Amount:
                                        </p>
                                        <div class="flex justify-between">
                                            <p class="font-semibold text-gray-700">
                                                £
                                            </p>
                                            <p class="font-bold">
                                                <span class="">{{
                            demoData.transactionData.transactionAmount.amount.toFixed(2)
                        }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <!-------------------------->
                    <!--ERINCHEMNT-------------->
                    <!-------------------------->
                    <transition enter-active-class="duration-500 ease-out opacity-0 delay-[800ms]"
                        enter-to-class="opacity-100" leave-active-class="duration-500 ease-in" leave-class="opacity-100"
                        leave-to-class="opacity-0">
                        <div v-if="demoData != undefined">
                            <!--Arrow Down-->
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                                class="w-5 h-5 mx-auto my-2">
                                <path fill-rule="evenodd"
                                    d="M8 2a.75.75 0 0 1 .75.75v8.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V2.75A.75.75 0 0 1 8 2Z"
                                    clip-rule="evenodd" />
                            </svg>
                            <!--Enriched Transaction Data-->
                            <p class="text-sm text-gray-800 font-semibold text-center pl-1">
                                Merchant Enrichment
                            </p>
                            <p class="text-xs text-gray-800 font-medium text-center pl-1 mb-2">
                                We enrich your transaction data with merchant information.
                            </p>
                            <div class="grid grid-cols-1 xl:grid-cols-2 gap-3">
                                <div>
                                    <div v-if="demoData.transactionData.enrichedCreditorData.merchant != null"
                                        class="bg-white px-4 py-4 rounded-xl shadow-xl max-w-md sm:max-w-xl mx-auto">
                                        <div class="flex justify-between items-center">
                                            <div class="flex w-full items-center pl-1">
                                                <img :src="demoData.transactionData.enrichedCreditorData.logo"
                                                    class="rounded-lg w-8 sm:h-10 w-8 sm:w-10 object-cover bg-white border border-gray-200" />
                                                <p class="font-medium text-normal sm:text-lg pl-2 text-gray-800">
                                                    {{ demoData.transactionData.enrichedCreditorData.merchant }}
                                                </p>
                                            </div>
                                            <div class="flex justify-end w-full">
                                                <p class="font-bold text-xl">
                                                    <span class="text-lg font-semibold">£</span> {{ demoData.transactionData.transactionAmount.amount.toFixed(2) }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="bg-gray-50 px-3 py-2 mt-4 rounded-md flex justify-between items-end w-full text-sm ">
                                            <p class="text-gray-800 font-medium text-left">
                                                Website:
                                            </p>
                                            <div class="flex font-semibold underline cursor-pointer">
                                                <a :href=demoData.transactionData.enrichedCreditorData.website target="_blank">
                                                    {{ demoData.transactionData.enrichedCreditorData.website }}
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            class="bg-gray-50 px-3 py-2 mt-2 rounded-md flex justify-between items-end w-full text-sm ">
                                            <p class="text-gray-800 font-medium text-left">
                                                Type:
                                            </p>
                                            <div class="flex font-semibold cursor-pointer">
                                                <p v-for="val, index in demoData.transactionData.enrichedCreditorData.labels"
                                                    :key="index">{{ val }}</p>
                                            </div>
                                        </div>
                                        <div  v-for="offerData,index in demoData.transactionData.offersAvailable" :key="index">
                                        <div
                                            class="bg-pink-50 text-pink-800 px-3 py-2 mt-2 rounded-md flex justify-between items-end w-full text-sm ">
                                            <p class="text-pink-900 font-medium text-left">
                                                Type of offer:
                                            </p>
                                            <div class="flex font-semibold">
                                                <p v-if="offerData.offerType == 'PAYMENT'">Payment-linked offer</p>
                                                <p v-if="offerData.offerType == 'ONLINE'">Online affiliate offer</p>
                                                <p v-if="offerData.offerType == 'GIFTCARD'">Gift purchase offer</p>
                                            </div>
                                        </div>
                                        <div v-if="offerData.offerType == 'ONLINE'"
                                            class="bg-pink-50 text-pink-800 px-3 py-2 mt-2 rounded-md flex justify-between items-center w-full text-sm ">
                                            <p class="text-pink-900 font-medium text-left">
                                                You could earn:
                                            </p>
                                            <p class="text-pink-900 font-semibold text-left lowercase">
                                                {{offerData.displayRules[0].description}}
                                            </p>
                                        </div>
                                        <div v-if="offerData.offerType == 'PAYMENT'"
                                            class="bg-pink-50 text-pink-800 px-3 py-2 mt-2 rounded-md flex justify-between items-center w-full text-sm ">
                                            <p class="text-pink-900 font-medium text-left">
                                                End-user cashback:
                                            </p>
                                            <div class="flex text-right font-semibold max-w-[150px]">
                                                <p>
                                                    {{offerData.displayRules[0].description}}
                                                </p>
                                            </div>
                                        </div>
     
                                    </div>
                                        <!--<div class="grid grid-cols-2 gap-3 my-2">
                                            
                                            <div v-if="demoData.transactionData.offersAvailable.length > 0">Offer descriprion</div>
                                            <div v-if="demoData.transactionData.offersAvailable.length > 0">Earn
                                            {{ demoData.cashbackObject.cashbackRuleApplied.conditions[0].value.endUserValue }}% when you spend at
                                            {{ demoData.transactionData.enrichedCreditorData.merchant }}</div>
                                        </div>-->
                                    </div>
                                    <div v-else
                                        class="flex bg-white p-3 rounded-xl shadow-xl flex gap-x-2 max-w-md sm:max-w-xl mx-auto">
                                        <div class="flex w-full">
                                            <div class="bg-pink-50 py-3 px-4 rounded-lg w-full">
                                                <p class="text-sm text-pink-900 font-semibold text-left">
                                                    No merchant indentified ⚠
                                                </p>
                                                <div class="flex">
                                                    <p class="font-semibold ">
                                                        Try a different transaction string
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="bg-white px-4 py-4 rounded-xl shadow-xl max-w-md sm:max-w-xl mx-auto ">
                                        <vue-json-pretty v-if="demoData != undefined"  :data="demoData.transactionData" style="font-size: 11px;" class="bg-gray-50 max-h-96 overflow-y-auto rounded-lg p-2"/>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </transition>
                    <!-------------------------->
                    <!--CASHBACK FUFILLMENT----->
                    <!-------------------------->
                    <transition enter-active-class="duration-500 ease-out opacity-0 delay-[1200ms]"
                        enter-to-class="opacity-100" leave-active-class="duration-500 ease-in" leave-class="opacity-100"
                        leave-to-class="opacity-0">
                        <div
                            v-if="demoData != undefined && demoData.transactionData.enrichedCreditorData.merchant != null && demoData.cashbackObject != null">
                            <div>
                                <!--Arrow Down-->
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                                    class="w-5 h-5 mx-auto my-2">
                                    <path fill-rule="evenodd"
                                        d="M8 2a.75.75 0 0 1 .75.75v8.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V2.75A.75.75 0 0 1 8 2Z"
                                        clip-rule="evenodd" />
                                </svg>
                                <!--Enriched Transaction Data-->
                                <p class="text-sm text-gray-800 font-semibold text-center pl-1">
                                    Cashback fufillment
                                </p>
                                <p class="text-xs text-gray-800 font-medium text-center pl-1 mb-2">
                                    Communicate with merchants for verification and payment.
                                </p>
                                <div class="grid grid-cols-1 xl:grid-cols-2 gap-3">
                                    <div>
                                        <div class="bg-white px-4 py-4 rounded-xl shadow-xl max-w-md sm:max-w-xl mx-auto">
                                            <div @click="notifySystem = true;sendTransaction=false;verifyTransaction=false;merchantPayout=false;" v-if="demoData.transactionData.offersAvailable.length > 0"
                                                :class="notifySystem ? 'bg-slate-100 border border-gray-600':'bg-white border border-gray-200' " 
                                                class="hover:bg-slate-50 cursor-pointer text-slate-900 p-2 rounded-md flex justify-start gap-3 items-center w-full text-xs sm:text-sm mb-2 ">
                                                <p
                                                    class="font-semibold bg-slate-800 rounded-md text-white w-7 h-7 flex justify-center items-center">
                                                    1.
                                                </p>
                                                <div class="flex text-left font-medium ">
                                                    <p>We notify your systems 🔔</p>
                                                </div>
                                            </div>
                                            <div @click="notifySystem = false;sendTransaction=true;verifyTransaction=false;merchantPayout=false;" v-if="demoData.transactionData.offersAvailable.length > 0"
                                                :class="sendTransaction ? 'bg-slate-100 border border-gray-600':'bg-white border border-gray-200' " 
                                                class="hover:bg-slate-50 cursor-pointer text-slate-900 p-2 rounded-md flex justify-start gap-3 items-center w-full text-xs sm:text-sm mb-2 ">
                                                <p
                                                    class="font-semibold bg-slate-800 rounded-md text-white w-7 h-7 flex justify-center items-center">
                                                    2.
                                                </p>
                                                <div class="flex text-left font-medium">
                                                    <p>We send transaction to merchant 🧾</p>
                                                </div>
                                            </div>
                                            <div @click="notifySystem = false;sendTransaction=false;verifyTransaction=true;merchantPayout=false;" v-if="demoData.transactionData.offersAvailable.length > 0"
                                                :class="verifyTransaction ? 'bg-slate-100 border border-gray-600':'bg-white border border-gray-200' " 
                                                class="hover:bg-slate-50 cursor-pointer text-slate-900 p-2 rounded-md flex justify-start gap-3 items-center w-full text-xs sm:text-sm mb-2 ">
                                                <p
                                                    class="font-semibold bg-slate-800 rounded-md text-white w-7 h-7 flex justify-center items-center">
                                                    3.
                                                </p>
                                                <div class="flex text-left font-medium">
                                                    <p>Merchant verifies customer purchase ✅</p>
                                                </div>
                                            </div>
                                            <div @click="notifySystem = false;sendTransaction=false;verifyTransaction=false;merchantPayout=true;" v-if="demoData.transactionData.offersAvailable.length > 0"
                                                :class="merchantPayout ? 'bg-slate-100 border border-gray-600':'bg-white border border-gray-200' " 
                                                class="hover:bg-slate-50 cursor-pointer text-slate-900 p-2 rounded-md flex justify-start gap-3 items-center w-full text-xs sm:text-sm">
                                                <p
                                                    class="font-semibold bg-slate-800 rounded-md text-white w-7 h-7 flex justify-center items-center">
                                                    4.
                                                </p>
                                                <div class="flex text-left font-medium">
                                                    <p>Merchant pays us cashback 💰</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="bg-white px-4 py-4 rounded-xl shadow-xl max-w-md sm:max-w-xl mx-auto">
                                            <vue-json-pretty v-if="notifySystem"  :data="demoData.cashbackCreated" style="font-size: 11px;" class="bg-gray-50 max-h-96 overflow-y-auto rounded-lg p-2"/>
                                            <vue-json-pretty v-if="sendTransaction"  :data="demoData.cashbackBeingVerified" style="font-size: 11px;" class="bg-gray-50 max-h-96 overflow-y-auto rounded-lg p-2"/>
                                            <vue-json-pretty v-if="verifyTransaction"  :data="demoData.cashbackVerified" style="font-size: 11px;" class="bg-gray-50 max-h-96 overflow-y-auto rounded-lg p-2"/>
                                            <vue-json-pretty v-if="merchantPayout"  :data="demoData.cashbackReceived" style="font-size: 11px;" class="bg-gray-50 max-h-96 overflow-y-auto rounded-lg p-2"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="demoData != undefined">
                                <div v-if="demoData.transactionData.offersAvailable.filter(offer => offer.offerType == 'PAYMENT').length > 0">
                                    <!--Arrow Down-->
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
                                        class="w-5 h-5 mx-auto my-2">
                                        <path fill-rule="evenodd"
                                            d="M8 2a.75.75 0 0 1 .75.75v8.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V2.75A.75.75 0 0 1 8 2Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    <p class="text-sm text-gray-800 font-semibold text-center pl-1">
                                        Cashback earnings
                                    </p>
                                    <p class="text-xs text-gray-800 font-medium text-center pl-1 mb-2">
                                        We allocate and pay funds to you to distrubute to users.
                                    </p>
                                    <div if class="bg-white px-4 py-4 rounded-xl shadow-xl max-w-md mx-auto">
                                        <div class="grid grid-cols-2 gap-2">
                                            <div
                                                class="bg-green-50 text-green-900 border border-green-600 p-5 rounded-md w-full text-sm text-center">
                                                <p class="text-4xl font-medium">
                                                    👩‍💼
                                                </p>
                                                <p class="font-medium pb-2">
                                                    Your user's earnings:
                                                </p>
                                                <p class="text-4xl font-medium">
                                                    £{{
                                                    demoData.cashbackObject.payoutData.endUserCashbackReceivable.toFixed(2)
                                                    }}
                                                </p>
                                            </div>
                                            <div
                                                class="bg-blue-50 text-blue-900 border border-blue-600 p-5 rounded-md w-full text-sm text-center">
                                                <p class="text-4xl font-medium">
                                                    💸
                                                </p>
                                                <p class="font-medium pb-2">
                                                    Your commission:
                                                </p>
                                                <p class="text-4xl font-medium">
                                                    £{{
                                                    demoData.cashbackObject.payoutData.publisherCashbackReceivable.toFixed(2)
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    name: "manage-publsihers",
    components: {
        VueJsonPretty,

    },
    props: {
    },

    data() {
        return {

            webhook:{
                notifySystem:{status:"notify"},
                sendTransaction:{status:"send"},
                verifyTransaction:{status:"verify"},
                merchantPayout:{status:"pay"}

            },
           notifySystem: true,
           sendTransaction: false,
           verifyTransaction: false,
           merchantPayout: false,

            demoRequest: {
                description: "",
                amount: undefined,
            },
            demoData: undefined,
            loading: false,
            gay: false

        }
    },

    methods: {

        async handleDemo() {
            const token = localStorage.getItem('token')
            const api  = localStorage.getItem('apiType')

            try {
                this.demoData = undefined
                if (this.demoRequest.amount > 0) {
                    this.demoRequest.amount = 0 - this.demoRequest.amount
                }

                this.loading = true;
                const response = await fetch(`https://${api}.boogi.io/private/api/client/playground`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `${token}`,
                    },
                    body: JSON.stringify(this.demoRequest)
                });

                if (response.status === 200) {
                    var responseVal = await response.json()
                    this.demoData = responseVal

                    if(!this.demoData.transactionData.enrichedCreditorData.website.includes("https://"))
                    {
                        this.demoData.transactionData.enrichedCreditorData.website = "https://" + this.demoData.transactionData.enrichedCreditorData.website

                    }
                    this.demoRequest = {
                        description: "",
                        amount: 0
                    }
                    this.loading = false
                    this.explode()

                }

            } catch (error) {
                console.log(error)
                this.loading = false;
                this.showErrorModal = true;
            }
        }
    }
}
</script>
<style></style>
